import { action, computed, observable } from "mobx";
import NestStore from "~/stores/NestStore";
import Immersive3dTourZipProject from "~/models/Immersive3dTour/Immersive3dTourZipProject";
import Immersive3dTourZipProjectRepository from "~/repository/Immersive3dTour/Immersive3dTourZipProjectRepository";

class Immersive3dTourZipProjectStore extends NestStore {
  /**
   * @property {Immersive3dTourZipProject|null}
   */
  @observable immersive3dTourZipProject = null;

  /**
   * @property {number|null}
   */
  @observable tourId = null;

  /**
   * @property {Immersive3dTourZipProjectRepository|null}
   */
  immersive3dTourZipProjectRepository = null;

  constructor() {
    super();

    this.immersive3dTourZipProjectRepository = new Immersive3dTourZipProjectRepository();
  }

  @action
  load() {
    this.isLoading = true;

    return Promise.all([this.getOne()]).finally(() => {
      this.isLoading = false;
    });
  }

  @action
  getOne() {
    return this.immersive3dTourZipProjectRepository.fetchOne(this.tourId).then(response => {
      this.immersive3dTourZipProject = new Immersive3dTourZipProject(response.data.immersive3dTourZipProject);
    });
  }

  @computed
  get newPanoramasCount() {
    let newPanoramasCount = 0;

    if (!this.immersive3dTourZipProject) {
      return newPanoramasCount;
    }

    this.immersive3dTourZipProject.floors.forEach(floor => {
      newPanoramasCount += floor.panoramas.filter(panorama => !panorama.isDiscarded).length;
    });

    return newPanoramasCount;
  }
}

export default Immersive3dTourZipProjectStore;
